import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { createStore } from "../redux/storesSagas";
import { number, object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = object({
  remote_uid: number().typeError("Store ID must be a number").required("Store ID is required"),
  name: string().label("Name").required("Name is required"),
  organization_id: object().required("Organization is required"),
  clubready_chain_id: object().when("without_chain", {
    is: false,
    then: (schema) => schema.required("Chain is required"),
    otherwise: (schema) => schema.notRequired()
  })
}).required();

export const useAdd = () => {
  const dispatch = useDispatch();

  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      remote_uid: "",
      name: "",
      active: false,
      force_active: false,
      without_chain: false,
      opened: false
    }
  });

  const { handleSubmit } = form;

  const onSubmit = async (data) => {
    dispatch(createStore(data));
  };

  return {
    form,
    submit: handleSubmit(onSubmit)
  };
};
